// import { GridModelWord } from "./gridmodelword";

export class ClueWord {
  /**
   * @param {string} wordValue - The word string.
   * @param {GridModelWord} gridWord - The corresponding GridModelWord instance.
   * @param {object} clueBoard - The parent ClueBoard instance.
   */
  constructor(wordValue, gridWord, clueBoard) {
    this.wordValue = wordValue;
    this.gridWord = gridWord;
    this.clueBoard = clueBoard;
    this.usedTimes = 0;
    if (this.gridWord && typeof this.gridWord.setClueBoard === "function") {
      this.gridWord.setClueBoard(clueBoard);
      this.gridWord.solutionClue = this;
    }
  }

  isUsed() {
    return this.usedTimes > 0;
  }
  setUsed() {
    this.usedTimes += 1;
  }
  use() {
    this.usedTimes += 1;
  }
  unuse() {
    this.usedTimes -= 1;
  }

  getWordValue() {
    return this.wordValue;
  }

  getGridWord() {
    return this.gridWord;
  }

  getClueBoard() {
    return this.clueBoard;
  }

  getClueElement() {
    const li = document.createElement("li");
    if (this.isUsed()) {
      li.className = "checked";
    }

    li.textContent = this.wordValue;
    return li;
  }
}
